import titles from "@/store/lang/titles.json";
import { mapGetters, mapActions } from "vuex";
import Success from "../success/Success.vue";
import InvisibleRecaptcha from "vue-invisible-recaptcha";
export default {
  name: "RailboxContact",
  components: {
    Success,
    InvisibleRecaptcha,
  },
  data() {
    return {
      contactTitles: titles.railboxContact,
      panelOpen: 0,
      contacDescTick: false,
      contactDetailsValid: false,
      additionalInfoValid: false,
      contactDetailsTick: false,
      rules: {
        nameRules: [
          (v) => !!v || titles.rulesTitle.creditApplication.fieldIsRequired,
        ],
        emailRules: [
          (v) => !!v || titles.rulesTitle.creditApplication.email,
          (v) =>
            /.+@.+/.test(v) || titles.rulesTitle.creditApplication.validEmail,
        ],
        phoneNumberRules: [
          function(v) {
            if (v) {
              let value = v.replace(/\D/g, "");
              return (
                (!isNaN(parseFloat(value)) && value.length == 10) ||
                titles.rulesTitle.rentalPickup.siteContactPhone
              );
            }
            return titles.rulesTitle.rentalPickup.siteContactPhone;
          },
        ],
      },
      requestForm: {
        event_type: "railbox_contact_request",
        name: "",
        email: "",
        phone: "",
        additional_info: "",
        CountryCode: "",
      },
      isSubmitSuccessful: false,
      activeStep: 1,
      animation: "animate-in",
      isSubmitting: false,
    };
  },
  computed: {
    ...mapGetters(["getCountryCode"]),
    progress(){
      
      var pg =  (this.activeStep-1)/ 1*100;
      
      return pg;

    },
  },
  methods: {
    ...mapActions(["addFormRequest"]),
    validateContactDetailsFields() {
      this.contactDetailsValid = this.$refs.contactDetailsForm.validate();
      this.contactDetailsTick = this.contactDetailsValid;
      this.$refs.contactDetailsForm.validate();
    },
    validateAdditionalInfo() {
      this.additionalInfoValid = this.$refs.additionalInfoForm.validate();
      this.contacDescTick = this.additionalInfoValid;
    },
    getPriorPanel(event, idx) {
      event ? event.preventDefault() : null;
      switch (idx) {
        case 2:
          this.priorStep();
          break;
      }
    },
    getNextPanel(event, idx) {
      switch (idx) {
        case 1:
          this.validateAdditionalInfo();
          if (!this.additionalInfoValid) this.notValid();
          else this.nextStep();
          break;
        case 2:
          this.validateContactDetailsFields();
          if (!this.contactDetailsValid) {
            this.notValid();
          } else {
            this.submit();
          }
          break;
      }
    },
    submit() {
      this.panelOpen = null;
      this.requestForm.CountryCode = this.getCountryCode;
      this.isSubmitting = true;
      this.addFormRequest({
        data: this.requestForm,
        event_type: this.requestForm.event_type,
      })
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.ResponseMetadata &&
            response.data.ResponseMetadata.HTTPStatusCode == 200
          )
            this.isSubmitSuccessful = true;
          this.isSubmitting = false;
        })
        .catch((err) => {
          console.log(err);
          this.isSubmitting = false;
        });
    },
    getRequestForm() {
      this.requestForm = {
        event_type: "railbox_contact_request",
        name: "",
        email: "",
        phone: "",
        additional_info: "",
        CountryCode: this.getCountryCode,
      };
      this.isSubmitSuccessful = false;
      this.activeStep = 1;
      this.contacDescTick = false;
      this.contactDetailsTick = false;
    },
    priorStep() {
      this.animation = "animate-out";
      setTimeout(() => {
        this.animation = "animate-in";
        this.activeStep -= 1;
      }, 600);
    },

    nextStep() {
      this.animation = "animate-out";
      setTimeout(() => {
        this.animation = "animate-in";
        this.activeStep += 1;
      }, 600);
    },
    notValid() {
      this.animation = "animate-wrong";
      setTimeout(() => {
        this.animation = "";
      }, 400);
    },
    getStepperContent(step) {
      this.activeStep = step;
      switch (step) {
        case 1:
          this.contacDescTick = false;
          break;
        case 2:
          this.contactDetailsTick = false;
          break;
      }
    },
    isAllValid() {
      return (
        !(
          this.contacDescTick &&
          this.$refs &&
          this.$refs.contactDetailsForm &&
          this.$refs.contactDetailsForm.validate()
        ) || this.isSubmitting
      );
    },
    submitted(response) {
      /*resposne will have the reCAPTCHA token.
      If token is null or empty do nothing.*/
      if (!response) return;
      this.getNextPanel(null, this.activeStep);
    },
  },
};
